import { Navigate, Outlet } from 'react-router-dom';
import useApp from 'hooks/useApp';

export function AdminGuard() {
  const { user } = useApp();

  // Check if user is not admin, redirect to projects page
  if (!user?.role.includes('admin')) {
    return <Navigate to="/projects" replace />;
  }

  // If user is admin, render the protected route
  return <Outlet />;
} 